import { Modal, Spinner, Stack } from "react-bootstrap"


const LoadingSpinner = ({title}:{title?:string}) => {

	return (
		<Modal show={true} size="sm" backdrop={'static'} style={{backgroundColor:'transparent', display:'flex'}}>
			<Stack style={{alignSelf:'center'}} direction="horizontal">
				<div>{`Loading ${title ? title : ''} ... `}</div>
				<div style={{width:60, overflow:'hidden', marginLeft:20}}>
					<Spinner style={{ marginLeft:'auto', marginRight:'auto', marginTop:40, marginBottom:40}} animation="border" role="status" />
				</div>
				
			</Stack>
			
		</Modal>
		
	)
}

export default LoadingSpinner;